/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const EMPTY_SCREEN_ALERT = 'Global roles are visible in all customer realms.';
export const MODULE_LABEL = 'Application Module For This Role';
export const NO_BUILTIN_POLICIES_ADDED = 'No built-in policies added';
